import { Flex } from 'antd';
import { Button } from '../../common';
import ResendCode from './resendCode';
import { getCurrentTenantSupportEmail } from 'utils';

const Activation = ({ setIsActiationScreen, email }) => {
  const supportEmail = getCurrentTenantSupportEmail() || 'support@joinelevate.com';

  return (
    <Flex vertical gap={10}>
      <Flex vertical gap={24}>
        <Flex justify="start" align="center" gap={16}>
          <Button
            iconColor={'var(--ant-color-primary)'}
            icon={'BackArrowIcon'}
            type={'text'}
            onClick={() => setIsActiationScreen(false)}
            className={'back-button'}
          />
          <div className="text-navigate">Back</div>
        </Flex>
        <Flex vertical gap={40}>
          <Flex vertical justify="start" align="start" gap={12}>
            <h2 className="heading-text">Verify Your Email to Activate Your Account</h2>
            <h5 className="h5-regular description-text">
              We've sent a confirmation email to {email}. Click the link to activate your account. Need help? Contact us
              at{' '}
              <a href={`mailto:${supportEmail}`} className="text-blue-500 underline">
                {supportEmail}
              </a>{' '}
              or{' '}
              <a href="tel:+18336692112" className="text-blue-500 underline">
                +1 (833) 669-2112
              </a>
              .
            </h5>
          </Flex>
          <ResendCode email={email} />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Activation;
